import api from './api';

const reportFormatService = {
  listCentres: async () => (await api.get('/report-formats/centres')).data,
  getForCentre: async (centreId) => (await api.get(`/report-formats/centres/${centreId}`)).data,
  getForBill: async (ledgerTransactionNo) => (await api.get(`/report-formats/bill/${encodeURIComponent(ledgerTransactionNo)}`)).data,
  saveForCentre: async (centreId, formatCode) => (await api.put(`/report-formats/centres/${centreId}`, { formatCode })).data,
};

export default reportFormatService;
